<app-service-detail>
    <div class="service-preview full-screen container-fluid py-3">
        <div class="w-100 preview-container">
          <iframe #previewIframe
                  frameborder="0"
                  scrolling="no"
                  height="{{scrollHeight}}px"
                  width="100%"
                  [src]="previewUrl"></iframe>
        </div>
        <div bsModal
             #childModal="bs-modal"
             class="modal"
             [config]="{backdrop: true, ignoreBackdropClick: true}"
             tabindex="-1"
             role="dialog"
             aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="rectangle modal-dialog"
                 [ngStyle]="style"
                 mwlResizable
                 [enableGhostResize]="true"
                 [resizeEdges]="{bottom: false, right: false, top: false, left: true}"
                 (resizeEnd)="onResizeEnd($event)">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button"
                                class="close ml-3"
                                aria-label="Close"
                                (click)="closeModal($event);">
                          <span class="color-primary" aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <translations-edit *ngIf="action === 'translation_edit'"
                                       [previewTranslation]="previewTranslation"
                                       (modalClosedWithoutReloadEvent)="childModal.hide();"
                                       (modalClosedEvent)="closeModal($event)"></translations-edit>
                    <!--registration-edit *ngIf="action === 'edit'"
                                       [serviceId]="serviceId"
                                       [fieldKey]="fieldKey"
                                       (modalClosedEvent)="closeModal($event)"></registration-edit-->
                </div>
            </div>
        </div>
    </div>
</app-service-detail>